import { render, staticRenderFns } from "./AirSegment.vue?vue&type=template&id=ea353a78&"
import script from "./AirSegment.vue?vue&type=script&lang=js&"
export * from "./AirSegment.vue?vue&type=script&lang=js&"
import style0 from "./AirSegment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports